import { useMemo } from "react"
import * as Yup from "yup"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"

const useProductGroupValidationSchema = () => {
    const { l10n } = useAppLocalization()

    return useMemo(
        () =>
            Yup.object().shape({
                name: Yup.string().required(l10n.getString("required-field")),
                isActive: Yup.boolean(),
                productGroupCode: Yup.object().shape({
                    id: Yup.number(),
                    name: Yup.string(),
                    number: Yup.string(),
                    description: Yup.string(),
                }),
                availableTime: Yup.boolean(),
                weekDays: Yup.array().of(Yup.string()),
                timeIntervalStart: Yup.date(),
                timeIntervalEnd: Yup.date().min(
                    Yup.ref("timeIntervalStart"),
                    l10n.getString("product-group-form-end-time-picker-min-error-label"),
                ),
                isLocked: Yup.boolean(),
            }),
        [l10n],
    )
}

export default useProductGroupValidationSchema
